var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1943_33420)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1943_33420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1511 4.13899L31.3274 2.39851L20.8634 8.43969L21.9593 10.0242L24.2541 13.341C27.0295 10.8947 30.2892 8.98524 33.8724 7.7775L32.1511 4.13899ZM63.7969 10.0242L64.8934 8.43969L54.4298 2.39851L53.605 4.13899L51.8831 7.77717C55.4667 8.98483 58.7267 10.8943 61.5024 13.3409L63.7969 10.0242ZM73.2264 23.761L74.9683 22.9367L68.927 12.4727L67.3422 13.5692L64.0252 15.8636C66.4716 18.6391 68.381 21.899 69.5887 25.4823L73.2264 23.761ZM48.4332 6.85609L48.7619 2.84189L48.9194 0.921875H36.8365L36.9941 2.84189L37.3226 6.85626C39.1519 6.49073 41.0128 6.30688 42.8783 6.3074C44.78 6.3074 46.6373 6.49702 48.4332 6.85609ZM18.4142 13.5692L16.8303 12.4727L10.7884 22.9367L12.5301 23.761L16.168 25.4824C17.3755 21.8993 19.2848 18.6397 21.7309 15.8643L18.4142 13.5692ZM53.6057 64.8364L54.4298 66.577L64.8934 60.5358L63.7969 58.9517L61.5025 55.6345C58.7269 58.0809 55.4671 59.9903 51.8839 61.198L53.6057 64.8364ZM12.5302 45.215L10.7885 46.0388L16.8304 56.5027L18.4143 55.4062L21.7314 53.1115C19.2853 50.3362 17.376 47.0768 16.1684 43.4939L12.5302 45.215ZM67.3429 55.4062L68.927 56.5027L74.9683 46.0388L73.2264 45.2144L69.5888 43.4928C68.3812 47.076 66.4718 50.3358 64.0256 53.1113L67.3429 55.4062ZM21.9593 58.9517L20.8634 60.5358L31.3274 66.577L32.1511 64.8364L33.8726 61.1979C30.2895 59.9903 27.0299 58.0809 24.2546 55.6348L21.9593 58.9517ZM70.5097 40.0436L74.5242 40.3719L76.4441 40.5288V28.4466L74.5242 28.6036L70.5097 28.9314C70.8753 30.7609 71.0592 32.6221 71.0587 34.4877C71.0592 36.3533 70.8753 38.2143 70.5097 40.0436ZM15.2468 28.9325L11.2319 28.6036L9.3125 28.4466V40.5288L11.2319 40.3719L15.2469 40.0434C14.8814 38.2141 14.6975 36.3532 14.698 34.4877C14.698 32.586 14.8876 30.7286 15.2468 28.9325ZM37.3224 62.1191L36.9941 66.1336L36.8365 68.0536H48.9194L48.763 66.1336L48.4347 62.119C46.6052 62.4847 44.744 62.6686 42.8783 62.6681C40.9763 62.6681 39.1187 62.4784 37.3224 62.1191Z",
    fill: "url(#paint0_linear_1943_33420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3792 1.42188H48.3767L48.2636 2.801L48.2636 2.80109L47.9803 6.26122C46.3245 5.96365 44.6196 5.80741 42.8784 5.8074L37.3792 1.42188ZM37.3792 1.42188L37.4925 2.80098L37.4925 2.80112L37.7756 6.26142C39.4593 5.95894 41.1669 5.80693 42.8783 5.8074L37.3792 1.42188ZM74.5242 28.6036L74.5649 29.1019L71.1046 29.3845C71.4071 31.0683 71.5591 32.7761 71.5587 34.4876L74.5242 28.6036ZM74.5242 28.6036L74.5649 29.1019L75.9441 28.9892M74.5242 28.6036L75.9441 28.9892M75.9441 28.9892V39.9863L74.5649 39.8735L71.1046 39.5906C71.4071 37.9069 71.5591 36.1993 71.5587 34.4879L75.9441 28.9892ZM37.3792 67.5536L37.4925 66.1746L37.4925 66.1744L37.7754 62.714C39.4316 63.0117 41.1367 63.168 42.8782 63.1681L37.3792 67.5536ZM37.3792 67.5536H48.377M37.3792 67.5536H48.377M48.377 67.5536L48.2646 66.1744L48.2646 66.1743L47.9817 62.7139M48.377 67.5536L47.9817 62.7139M47.9817 62.7139C46.2978 63.0165 44.5899 63.1686 42.8783 63.1681L47.9817 62.7139ZM11.1911 29.1019L14.6519 29.3854C14.3543 31.0414 14.198 32.7463 14.198 34.4876L11.1911 29.1019ZM11.1911 29.1019L11.191 29.1019L9.8125 28.9892M11.1911 29.1019L9.8125 28.9892M9.8125 28.9892V39.9863L11.1911 39.8735L14.652 39.5904C14.3496 37.9068 14.1976 36.1991 14.198 34.4877L9.8125 28.9892ZM63.3857 9.73966L63.3857 9.73973L61.408 12.5985C58.8176 10.4032 55.8327 8.65863 52.5732 7.48795L54.0568 4.3531L54.0569 4.35288L54.6494 3.10265L64.1735 8.60137L63.3857 9.73966ZM69.8779 24.7923C68.7072 21.533 66.9627 18.5483 64.7676 15.958L67.6266 13.9804L67.6267 13.9804L68.7653 13.1926L74.264 22.7168L73.0126 23.309L69.8779 24.7923ZM18.1296 13.9803L18.1297 13.9804L20.9885 15.9587C18.7937 18.5488 17.0493 21.5333 15.8787 24.7924L12.744 23.309L12.744 23.309L11.4927 22.7169L16.9919 13.1927L18.1296 13.9803ZM52.5739 61.4872C55.8331 60.3165 58.8178 58.572 61.408 56.377L63.3856 59.2361L63.3857 59.2363L64.1734 60.3741L54.6496 65.8727L54.0576 64.6225L54.0576 64.6224L52.5739 61.4872ZM12.744 45.6671L12.744 45.667L15.8791 44.1839C17.0498 47.4428 18.7942 50.4271 20.989 53.0171L18.1299 54.995L18.1297 54.9951L16.992 55.7827L11.4928 46.2587L12.744 45.6671ZM67.6274 54.9951L67.6273 54.9951L64.768 53.0169C66.9629 50.4267 68.7074 47.4421 69.878 44.1829L73.0125 45.6663L74.264 46.2586L68.7654 55.7827L67.6274 54.9951ZM31.6991 64.6225L31.1075 65.8727L21.5832 60.374L22.3704 59.2362L22.3704 59.2361L24.349 56.3771C26.939 58.572 29.9235 60.3165 33.1826 61.4871L31.6992 64.6225L31.6991 64.6225ZM21.5832 8.60146L31.1075 3.10278L31.6991 4.35281L31.6992 4.35288L33.1825 7.48827C29.9232 8.65901 26.9386 10.4035 24.3484 12.5986L22.3705 9.73977L22.3704 9.73971L21.5832 8.60146Z",
    stroke: "#FFF530"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1943_33420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8363 72.0416H33.9176L32.5096 71.6636L22.9434 66.1406V85.5651L36.2335 80.716L42.8788 78.2918L49.5227 80.716L62.8131 85.5651V66.1407L53.2477 71.6634L51.8363 72.0416Z",
    fill: "url(#paint1_linear_1943_33420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8363 72.5416H51.9021L51.9657 72.5246L53.3771 72.1463L53.4407 72.1293L53.4977 72.0964L62.3131 67.0067V84.8505L49.694 80.2463L43.0502 77.8221L42.8788 77.7595L42.7074 77.822L36.0622 80.2463L36.0622 80.2463L23.4434 84.8505V67.0066L32.2596 72.0966L32.3165 72.1295L32.38 72.1465L33.7879 72.5245L33.8516 72.5416H33.9176H51.8363Z",
    stroke: "#FFF530"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1943_33420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 34.4881C18.6641 37.6677 19.2903 40.8162 20.5071 43.7538C21.7239 46.6915 23.5074 49.3606 25.7558 51.609C28.0041 53.8573 30.6733 55.6408 33.6109 56.8576C36.5486 58.0744 39.6971 58.7007 42.8767 58.7007C46.0564 58.7007 49.2049 58.0744 52.1425 56.8576C55.0801 55.6408 57.7493 53.8573 59.9977 51.609C62.246 49.3606 64.0295 46.6915 65.2463 43.7538C66.4631 40.8162 67.0894 37.6677 67.0894 34.4881C67.0894 28.0665 64.5384 21.9079 59.9977 17.3671C55.4569 12.8264 49.2983 10.2754 42.8767 10.2754C36.4551 10.2754 30.2965 12.8264 25.7558 17.3671C21.215 21.9079 18.6641 28.0665 18.6641 34.4881Z",
    fill: "url(#paint2_linear_1943_33420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9691 43.5625C19.7774 40.6855 19.1641 37.602 19.1641 34.4881C19.1641 28.1991 21.6624 22.1677 26.1093 17.7207C30.5563 13.2737 36.5877 10.7754 42.8767 10.7754C49.1657 10.7754 55.1971 13.2737 59.6441 17.7207C64.0911 22.1677 66.5894 28.1991 66.5894 34.4881C66.5894 37.602 65.976 40.6855 64.7844 43.5625C63.5927 46.4395 61.846 49.0535 59.6441 51.2554C57.4422 53.4574 54.8281 55.204 51.9512 56.3957C49.0742 57.5874 45.9907 58.2007 42.8767 58.2007C39.7627 58.2007 36.6792 57.5874 33.8023 56.3957C30.9253 55.204 28.3113 53.4574 26.1093 51.2554C23.9074 49.0535 22.1608 46.4395 20.9691 43.5625Z",
    stroke: "#FFF530"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1943_33420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3015 43V24.536L40.6455 27.736H36.1015L42.6295 19.96H46.7575V43H43.3015Z",
    fill: "#8A530F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1943_33420",
    x: 9.3125,
    y: 0.921875,
    width: 70.1309,
    height: 70.1318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.494118 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1943_33420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1943_33420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1943_33420",
    x: 22.9434,
    y: 66.1406,
    width: 42.8691,
    height: 22.4248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.494118 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1943_33420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1943_33420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1943_33420",
    x: 18.6641,
    y: 10.2754,
    width: 51.4258,
    height: 51.4258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.494118 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1943_33420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1943_33420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1943_33420",
    x: 36.1016,
    y: 19.96,
    width: 12.6562,
    height: 25.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.494118 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1943_33420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1943_33420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1943_33420",
    x1: 42.8783,
    y1: 0.921875,
    x2: 42.8783,
    y2: 68.0536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#FFF530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FBD161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1943_33420",
    x1: 42.8782,
    y1: 66.1406,
    x2: 42.8782,
    y2: 85.5651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#FFF530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FBD161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1943_33420",
    x1: 18.3041,
    y1: 10.478,
    x2: 77.0084,
    y2: 92.3911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#FFF530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FBD161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1943_33420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.6435,
    height: 84.6435,
    fill: "white",
    transform: "translate(0.556641 0.921875)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal1);
export default __webpack_public_path__ + "static/media/medal1.95456f8a4696b9da5b2c3a92c5dc8c7f.svg";
export { ForwardRef as ReactComponent };